/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export function ApplyFirmwareController($scope, $mdDialog, $q, firmwareService, type, entities) {

    var vm = this;

    vm.$onInit = function () {
        vm.entities = entities;
        vm.type = type;
        vm.firmware = {
            update: {
                force: false
            }
        };
        vm.cancel = cancel;
        vm.save = save;
        vm.loading = false;
    };

    function saveFirmware(type, entities, firmware) {
        var tasks = [];
        entities.forEach((entity) => {
            tasks.push(firmwareService.saveFirmwareDesired(type, entity.id.id, firmware));
        });
        return $q.all(tasks);
    }

    function save() {
        $scope.$broadcast('form-submit');
        if ($scope.theForm.$valid) {
            vm.loading = true;
            if (!vm.firmware.download.timestamp && !vm.firmware.download.maxRandomDelay) {
                delete vm.firmware.download;
            }
            var promise = saveFirmware(vm.type, vm.entities, vm.firmware);
            promise.then(function success() {
                vm.loading = false;
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }

    function cancel() {
        $mdDialog.cancel();
    }

}


// WEBPACK FOOTER //
// ./src/app/firmware/firmware.controller.js